import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Electricmeter } from './electricmeter.model';
import { ElectricmeterService } from './electricmeter.service';
@Injectable()
export class ElectricmeterPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private electricmeterService: ElectricmeterService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.electricmeterService.find(id).subscribe((electricmeter) => {
                electricmeter.updated = this.datePipe
                    .transform(electricmeter.updated, 'yyyy-MM-ddThh:mm');
                electricmeter.created = this.datePipe
                    .transform(electricmeter.created, 'yyyy-MM-ddThh:mm');
                electricmeter.lastValueChanged = this.datePipe
                    .transform(electricmeter.lastValueChanged, 'yyyy-MM-ddThh:mm');
                this.electricmeterModalRef(component, electricmeter);
            });
        } else {
            return this.electricmeterModalRef(component, new Electricmeter());
        }
    }

    electricmeterModalRef(component: Component, electricmeter: Electricmeter): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.electricmeter = electricmeter;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/electricmeter/electricmeter-popup.service.ts